export default "__VITE_ASSET__CT_1nLhS__"